type FocusedInspectionAssetReference = {
  identifier: string
  instanceId?: string
  instance?: {
    _id: string
  }
  spec?: {
    identifier: string
  }
}

const buildFocusedInspectionAssetCandidates = (
  asset: FocusedInspectionAssetReference,
) =>
  [
    asset.instanceId,
    asset.instance?._id,
    asset.identifier,
    asset.spec?.identifier,
  ].filter((candidate): candidate is string => !!candidate)

export const resolveFocusedInspectionAssetId = (
  asset: FocusedInspectionAssetReference,
) => buildFocusedInspectionAssetCandidates(asset)[0]

export const matchesFocusedInspectionAssetId = ({
  asset,
  focusedFileId,
}: {
  asset: FocusedInspectionAssetReference
  focusedFileId?: string | null
}) => {
  if (!focusedFileId) return false

  return buildFocusedInspectionAssetCandidates(asset).some(
    (candidate) => candidate === focusedFileId,
  )
}
